import { useOptions } from '../options.ts';

/**
 * A text input backed by a managed list.
 *
 * Uses a native datalist rather than a select: the common values are one click,
 * but a one-off can still be typed. A hard select would either block an unusual
 * job or push it outside the system.
 */
export default function OptionInput({
  list, value, onChange, placeholder, id, type = 'text',
}: {
  list: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  id?: string;
  type?: 'text' | 'number';
}) {
  const options = useOptions();
  const values = options[list] ?? [];
  const listId = `opt-${list}`;

  return (
    <>
      <input
        id={id}
        type={type}
        list={values.length ? listId : undefined}
        value={value}
        placeholder={placeholder ?? (values[0] ? `e.g. ${values[0]}` : '')}
        onChange={(e) => onChange(e.target.value)}
      />
      {values.length > 0 && (
        <datalist id={listId}>
          {values.map((v) => <option key={v} value={v} />)}
        </datalist>
      )}
    </>
  );
}
